import React from 'react';

import classes from './TwoFAStep.module.scss';
import { TwoFAAuth } from '../../../../../auth-management';
import { ButtonRow } from '../../components/ButtonRow/ButtonRow';
import { getRouteParam } from '../../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../../constants/pathQueryParams';

const twoFaAuthFormId = 'two-fa-auth-form';

type TwoFAStepProps = {
  onVerifyCode: (consumer: string, code: string) => Promise<void>;
};

const TwoFAStep = ({ onVerifyCode }: TwoFAStepProps) => {
  const phoneNumber = getRouteParam(pathQueryParams.phoneNumber);

  if (!phoneNumber) {
    throw new Error('Phone number is not defined');
  }

  return (
    <>
      <h1 className={classes.pageTitle}>Welcome to Challenge</h1>
      <TwoFAAuth
        formId={twoFaAuthFormId}
        onVerifyCode={onVerifyCode}
        phoneNumber={phoneNumber}
      />
      <ButtonRow formId={twoFaAuthFormId} />
    </>
  );
};

export { TwoFAStep };
